import React from 'react'
import './Success.css'

const Success = () => {
  return (
    <>
    <div className="content">
      <h1 id="thank">Thank You for Registering!</h1>
      <div className="img">
        
        <img id='logo' src="assets/IETE_logo.jpg" alt="IETE_logo" />
        
      </div>
      <p><b>Keep up with the buzz - Stay tuned to our official <a href="https://www.instagram.com/iete_thapar/" target='_blank'>Instagram</a> handle for more updates!</b></p>
    </div>
    </>
  )
}

export default Success